import React, {PureComponent} from 'react';
import Header from '../components/Header/Header';
import CategoriesFilter from '../containers/ConnectedCategoriesFilter';
import {gettext} from '../translations';
import Layout from 'eventbrite_design_system/layout/Layout';

import NotFoundIllustration from '../svgs/404-illustration.svg';

export default class NotFound extends PureComponent {
    componentDidMount() {
        const {
            categoriesFetching,
            fetchCategories,
        } = this.props;

        if (!categoriesFetching) {
            fetchCategories();
        }
    }

    render() {
        return (
            <Layout maxWidth="large" hasHorizontalGutters={true}>
                <div className="eds-l-mar-bot-8">
                    <div>
                        <Header 
                            headline={gettext('Page not found')}
                            secondary={gettext('Try searching for apps or exploring categories below')}
                            alwaysShowSecondary={true}
                            align="left"
                            hero={NotFoundIllustration}
                            margin={false}
                            heroVerticalAlignCenter={false}
                        />
                        <div className="eds-l-mar-top-4">
                            <CategoriesFilter />
                        </div>
                    </div>
                </div>
            </Layout>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/NotFound.js